export const KEY_CODES = {
  ENTER: 13,
  ESC: 27,

  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  BOTTOM_ARROW: 40,
}

const arrowKeysSet = new Set([KEY_CODES.LEFT_ARROW, KEY_CODES.UP_ARROW, KEY_CODES.RIGHT_ARROW, KEY_CODES.BOTTOM_ARROW])
export const isArrowKey = (key: number) => arrowKeysSet.has(key)

